import { createAsyncMiddleware } from '@tgtg/core/async/middleware';
import createSagaMiddleware from 'redux-saga';

import baseApiSlice from '../../api/baseApiSlice';

export const sagaMiddleware = createSagaMiddleware();
export const asyncMiddleware = createAsyncMiddleware();

export const middlewares = [sagaMiddleware, asyncMiddleware, baseApiSlice.middleware] as const;
